import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { RichTextToolbarType } from '../enum';
const Toolbar = (props) => {
    const { id, prefixCls } = props;
    return (React.createElement("div", { id: id || 'toolbar', className: `${prefixCls}-toolbar` },
        React.createElement("button", { type: "button", className: "ql-bold" }),
        React.createElement("button", { type: "button", className: "ql-italic" }),
        React.createElement("button", { type: "button", className: "ql-underline" }),
        React.createElement("button", { type: "button", className: "ql-strike" }),
        React.createElement("button", { type: "button", className: "ql-blockquote" }),
        React.createElement("button", { type: "button", className: "ql-list", value: "ordered" }),
        React.createElement("button", { type: "button", className: "ql-list", value: "bullet" }),
        React.createElement("button", { type: "button", className: "ql-image" }),
        React.createElement("button", { type: "button", className: "ql-link" }),
        React.createElement("select", { className: "ql-color" })));
};
let RichTextToolbar = class RichTextToolbar extends Component {
    renderToolBar(props) {
        const { prefixCls } = this.props;
        return React.createElement(Toolbar, Object.assign({ key: "toolbar", prefixCls: prefixCls }, props));
    }
    render() {
        const { id, toolbar, dataSet } = this.props;
        const props = {
            id,
            dataSet,
        };
        if (typeof toolbar === 'function') {
            return toolbar(props);
        }
        switch (toolbar) {
            case RichTextToolbarType.normal:
                return this.renderToolBar(props);
            default:
                return null;
        }
    }
};
RichTextToolbar.displayName = 'RichTextToolbar';
RichTextToolbar = __decorate([
    observer
], RichTextToolbar);
export default RichTextToolbar;
